'use strict';

/*@ngInject*/
module.exports = function () {
	return {
		scope: {
			viewMode: '='
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function controller() {
			var vm = this;
			vm.services = [];
			vm.isSearching = true;
		},
		template: require('./service-search.directive.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/services/service-search.directive.js
 **/